import { render, staticRenderFns } from "./StatisticsDashboard.vue?vue&type=template&id=330d52f0&scoped=true"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=js"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=js"
import style0 from "./StatisticsDashboard.vue?vue&type=style&index=0&id=330d52f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d52f0",
  null
  
)

export default component.exports